import React from "react";
import "./styles.css";
import Main from "./components/Main";
import Navbar from  './components/Navbar';
import Footer from './components/Footer';
import "bootstrap/dist/css/bootstrap.min.css";
import "./new-theme/assests/css/NewStyle.css";
// import "./new-theme/bootstrap.min.css";

export default class ClientPortal extends React.Component{
  render() {
    return(
      <React.Fragment>
        <Navbar />
        <Main />
        <Footer />
      </React.Fragment>
    );
  }
}
